<template>
  <div id="tasks-codes-item" class="relative flex items-center w-full gap-4"
    :class="{ 'py-2 border-b border-grey-200': readOnly }"

  >
    <!-- Tambahkan nomor urutan di sini -->
    <div
      v-if="kind === 'client'"
      class="absolute flex items-center justify-center flex-shrink-0 w-10 h-10 text-sm font-medium rounded-full top-2 -left-12 bg-light-purple"
    >
      <div class="relative flex flex-col items-center justify-center">
        <BlTextSubtitle2 :text="index + 1" class="text-pure-white" />
        <div class="absolute w-1 transform h-22 top-12 bg-slate-400" />
      </div>
    </div>

    <div
      class="w-full"
      :class="{
        'flex flex-col w-full gap-3 p-2 border bg-slate-200 border-slate-400 rounded-xl':
          kind === 'client'
      }"
    >
      <div class="flex items-center w-full gap-3">
        <BlSelectBox
          v-if="kind === 'client'"
          type="branch"
          class="w-32 "
          v-model="idInput"
          :options="codeOptions"
          @change="onChangeCode"
          :key="`select-${code.key}-${selectBoxKeys[code.key] || 0}`"
        />
        <div
          v-else-if="readOnly"
          class="flex items-center flex-shrink-0 w-18 h-11"
        >
          <BlTextBody1 :text="code.code" />
        </div>
        <input
          v-else
          type="text"
          class="flex-shrink-0 h-10 px-4 text-sm border rounded outline-none w-26 border-grey-200 focus:border-light-purple text-grey"
          :class="{ 'border-error-400': errors.code }"
          placeholder="Code"
          v-model="codeInput"
          @blur.prevent="onUpdate"
        />
        <!-- input code definition -->
        <input
          v-if="kind === 'client'"
          type="text"
          class="w-full h-10 px-4 text-sm border rounded outline-none border-grey-200 focus:border-light-purple text-grey"
          :class="{ 'border-error-400': errors.title }"
          placeholder="Type task title"
          v-model="codeTitleInput"
          @blur.prevent="onUpdate"
        />
        <div
          v-else-if="readOnly"
          class="flex items-center w-full h-11"
        >
          <BlTextBody1 :text="code.code_definition" />
        </div>
        <input
          v-else
          type="text"
          class="w-full h-10 px-4 text-sm border rounded outline-none border-grey-200 focus:border-light-purple text-grey"
          :class="{ 'border-error-400': errors.codeDefinition }"
          placeholder="Code definition"
          v-model="codeDefinitionInput"
          @blur.prevent="onUpdate"
        />
        <!-- select color -->
        <div class="relative">
          <div
            :data-id="`prompt-symbol-${id}`"
            :class="[
              symbolOpened ? 'border-light-purple ' : 'border-grey-200 ',
              readOnly ? 'pointer-events-none bg-transparent' : '',
              kind === 'client'
                ? ' bg-pure-white border-grey-200 w-26'
                : !readOnly
                ? 'w-26 bg-pure-white'
                : '',
                !readOnly ? 'border' : ''
            ]"
            class="relative flex items-center justify-between h-10 px-4 rounded "
            @click.prevent="kind !== 'client' && (symbolOpened = !symbolOpened)"
          >
            <div
              :class="[kind !== 'client' ? 'w-10 h-1' : 'w-26 h-1', readOnly ? 'w-15' : '']"
              :style="{ backgroundColor: colorInput }"
            />
            <BlIcon
              v-if="kind !== 'client' && !readOnly"
              :data-id="`prompt-symbol-${id}`"
              class="absolute w-5 h-5 transition-all duration-300 right-4"
              icon="chevron-down"
              :style="symbolOpened ? 'rotate: 180deg' : ''"
            />
          </div>
          <div
            :data-id="`prompt-symbol-${id}`"
            v-if="symbolOpened"
            class="absolute right-0 z-10 w-40 px-2 py-2 mt-2 space-y-4 overflow-y-auto border rounded shadow-md max-h-48 bg-pure-white border-grey-200"
          >
            <div :data-id="`prompt-symbol-${id}`">
              <div
                :data-id="`prompt-symbol-${id}`"
                class="grid grid-cols-4 grid-rows-2 gap-3 p-2"
              >
                <div
                  v-for="color in Object.keys(taskCodeColors)"
                  :key="color"
                  :data-id="`prompt-symbol-${id}`"
                  class="flex items-center justify-center w-6 h-6 border-2 rounded cursor-pointer"
                  :class="[
                    colorInput === taskCodeColors[color].primaryColor
                      ? 'border-light-purple'
                      : 'border-transparent'
                  ]"
                  :style="{
                    backgroundColor: taskCodeColors[color].primaryColor
                  }"
                  @click="selectColor(taskCodeColors[color].primaryColor)"
                  :title="color"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <textarea
        v-if="kind === 'client'"
        class="w-full h-20 px-4 py-3 text-sm border rounded outline-none border-grey-200 focus:border-light-purple text-grey"
        :class="{ 'border-error-400': errors.description }"
        placeholder="Type description"
        v-model="descriptionInput"
        @blur.prevent="onUpdate"
        :style="{ resize: 'none' }"
      />
    </div>

    <div
      v-if="!readOnly"
      class="flex items-center cursor-pointer"
      :class="[
        isDeleteDisabled ? 'cursor-not-allowed ' : '',
        kind === 'client'
          ? 'absolute -right-12 top-2 bg-tomato-100 rounded-full p-2'
          : ''
      ]"
      :disabled="isDeleteDisabled"
      @click="
        !isDeleteDisabled && (kind === 'client' ? onRemove() : onDelete())
      "
    >
      <BlIcon
        class="w-5 h-5"
        icon="delete"
        :color="isDeleteDisabled ? 'grey' : 'error'"
        :tooltipPosition="isDeleteDisabled ? tooltipPosition : ''"
        :tooltip="
          isDeleteDisabled
            ? kind === 'client' && defaultTasks.length <= 1
              ? 'At least one task must remain.'
              : 'This code is already associated with targets and cannot be deleted.'
            : ''
        "
      />
    </div>

    <BlBackdrop
      v-if="deleteOpened"
      title="Delete the task"
      label="Delete"
      description="Deleting this code from the repository will only affect new targets going forward. Are you sure you want to proceed? This action is irreversible."
      type="error"
      empty
      @backdrop-close="deleteOpened = false"
      @backdrop-action="onRemove"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BlBackdrop from "../../BlBackdrop.vue";
import BlIcon from "../../BlIcon.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlSelectBox from "../../BlSelectBox.vue";

export default {
  name: "TasksCodesItem",
  components: {
    BlIcon,
    BlTextBody2,
    BlBackdrop,
    BlTextBody1,
    BlTextSubtitle2,
    BlSelectBox
  },
  props: {
    code: { type: Object, default: () => {} },
    readOnly: { type: Boolean, default: false },
    directDelete: { type: Boolean, default: false },
    disabledDelete: { type: Boolean, default: false },
    tooltipDelete: { type: Boolean, default: false },
    kind: { type: String, default: "" },
    index: { type: Number, default: 0 },
    tasks: { type: Array, default: () => [] },
    defaultTasks: { type: Array, default: () => [] },
    tooltipPosition: { type: String, default: "bottom" }
    // @update
    // @delete
  },
  data() {
    return {
      deleteOpened: false,
      //
      idInput: 0,
      idCode: 0,
      codeInput: "",
      codeTitleInput: "",
      colorInput: "",
      codeDefinitionInput: "",
      descriptionInput: "",
      position: null,
      //
      errors: {
        code: false,
        title: false,
        color: false,
        codeDefinition: false
      },
      //
      symbolOpened: false,
      taskCodeColors: {
        moss: {
          primaryColor: "#A7C957",
          secondaryColor: "#A7C957",
          textColor: "#FFFFFF"
        },
        salmon: {
          primaryColor: "#F4855D",
          secondaryColor: "#F4855D",
          textColor: "#FFFFFF"
        },
        gold: {
          primaryColor: "#F4D430",
          secondaryColor: "#F4D430",
          textColor: "#FFFFFF"
        },
        lake: {
          primaryColor: "#2AB1A8",
          secondaryColor: "#2AB1A8",
          textColor: "#FFFFFF"
        },
        cherry: {
          primaryColor: "#FF4447",
          secondaryColor: "#FF4447",
          textColor: "#FFFFFF"
        },
        sky: {
          primaryColor: "#487ADF",
          secondaryColor: "#487ADF",
          textColor: "#FFFFFF"
        },
        lavender: {
          primaryColor: "#A533FF",
          secondaryColor: "#A533FF",
          textColor: "#FFFFFF"
        },
        tangerine: {
          primaryColor: "#F57E00",
          secondaryColor: "#F57E00",
          textColor: "#FFFFFF"
        }
      },
      selectBoxKeys: {}
    };
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-task-code-color-${combination}`;
    },
    codeOptions() {
      return this.tasks.map(task => ({
        value: task.id,
        label: task.code,
        disabled: this.isCodeAlreadyUsed(task.id, this.code.key)
      }));
    },
    isDeleteDisabled() {
      return (
        (this.kind === "client" && this.defaultTasks.length <= 1) ||
        this.disabledDelete
      );
    }
  },
  watch: {
    code: {
      deep: true,
      immediate: true,
      handler(val) {
        this.assignCode(val);
      }
    },
    defaultTasks: {
      deep: true,
      handler(val) {
        this.$set(
          this.selectBoxKeys,
          this.code.key,
          (this.selectBoxKeys[this.code.key] || 0) + 1
        );
      }
    },
    symbolOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      } else {
        window.removeEventListener("click", this.closeHandler);
        this.onUpdate();
      }
    }
  },
  mounted() {
    if (this.code && this.code.key && !this.selectBoxKeys[this.code.key]) {
      this.$set(this.selectBoxKeys, this.code.key, 0);
    }
  },
  methods: {
    ...mapActions(["showToast"]),
    //
    assignCode(code) {
      if (!code) return;

      this.idInput = code.id;
      this.idCode = code.id;
      this.codeInput = code.code || "";
      this.codeTitleInput = code.title || "";
      this.codeDefinitionInput = code.code_definition || "";
      this.colorInput = code.color || "";
      this.descriptionInput = code.description || "";
      this.position = code.position || null;
    },

    isCodeAlreadyUsed(codeId, originalCodeId) {
      const isUsedInDefaultTasks = this.defaultTasks.some(
        task => task.id === codeId && task.key !== originalCodeId
      );
      return isUsedInDefaultTasks;
    },

    //
    onUpdate() {
      const params = {
        key: this.code.key,
        id: this.idInput,
        id_code: this.idCode,
        code: this.codeInput,
        title: this.codeTitleInput,
        description: this.descriptionInput,
        color: this.colorInput,
        position: this.position,
        code_definition: this.codeDefinitionInput
      };

      if (!params.code && !this.isCodeReadyUsed && this.kind !== "client") {
        this.errors.code = true;
        const title = "The task code should not empty.";
        this.showToast({ title, message: "", type: "error" });
        return;
      }
      this.errors.code = false;

      if (
        !params.code_definition.length &&
        !this.isCodeReadyUsed &&
        this.kind !== "client"
      ) {
        this.errors.codeDefinition = true;
        const title = "Task code definition must have at least 1 character.";
        this.showToast({ title, message: "", type: "error" });
        if (this.kind === "client") {
          this.$emit("update", params);
        }
        return;
      }
      this.errors.title = false;
      this.errors.codeDefinition = false;

      this.$emit("update", params);
    },
    onChangeCode(selectedValue) {
      const findCode = this.tasks.find(i => i.id === selectedValue);
      if (findCode) {
        if (this.isCodeAlreadyUsed(selectedValue, this.code.key)) {
          return;
        }

        this.idInput = findCode.id;
        this.idCode = findCode.id;
        this.codeInput = findCode.code || "";
        this.colorInput = findCode.color || "";

        this.position = findCode.position;
      }

      this.onUpdate();
    },
    selectColor(color) {
      this.colorInput = color;
    },
    openDelete() {
      if (this.isDeleteDisabled) {
        return;
      }

      if (this.directDelete) {
        this.onRemove();
      } else {
        this.deleteOpened = true;
      }
    },
    onRemove() {
      this.deleteOpened = false;
      if (this.kind === "client") {
        this.$emit("delete", { key: this.code.key });
      } else {
        this.$emit("delete", { id: this.code.id });
      }
    },
    onDelete() {
      if (!this.isDeleteDisabled) {
        this.openDelete();
      }
    },
    closeHandler(e) {
      let close = true;
      if (e.target && e.target.dataset && e.target.dataset.id) {
        const id = e.target.dataset.id || "";
        if (`prompt-symbol-${this.id}` === id) close = false;
      }
      if (close) {
        window.removeEventListener("click", this.closeHandler);
        this.symbolOpened = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/sbt/TasksCodesItem.vue